
// This component is now empty since we're only using German
export const LanguageToggle = () => {
  return null;
};
